import { render, staticRenderFns } from "./orgEffect.vue?vue&type=template&id=3b773480&"
import script from "./orgEffect.vue?vue&type=script&lang=js&"
export * from "./orgEffect.vue?vue&type=script&lang=js&"
import style0 from "./orgEffect.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports